export default __webpack_public_path__ + "static/media/person.f26e4950.svg";